import { useScaffold } from "@Light/scaffold";
import { clsx } from "clsx";
import { Card } from "./Card";
import { PlanHighlights, usePlanHighlights } from "../PlanHighlights";

export type ConfirmRatePlanHighlightsProps = {
  label: string;
};

/** Plan highlights styled as a labeled card (rate / confirm / waiting screens). */
export const ConfirmRatePlanHighlights = ({
  label,
}: ConfirmRatePlanHighlightsProps) => {
  const scaffold = useScaffold();
  const highlights = usePlanHighlights();

  if (highlights.length === 0) {
    return null;
  }

  return (
    <Card label={label}>
      <div
        className={clsx(
          "flex flex-col gap-2 text-sm",
          scaffold.page.colors.text.secondary,
        )}
      >
        <PlanHighlights />
      </div>
    </Card>
  );
};
